/// <amd-module name="Repos/Messages/Components/ReposMessages" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { Observer } from "VSSUI/Observer";
import { IRepositoryMessage } from "../Contracts";
import { IReposMessagesService } from "../ReposMessagesService";
import { PullRequestSuggestionMessageType } from "../ReposSuggestionsService";

export interface IReposMessagesProps {
    /**
     * CSS class name to supply to the messages container
     */
    className?: string;

    /**
     * Whether or not to show pull request suggestions
     *
     * @default true
     */
    showPullRequestSuggestions?: boolean;

    /**
     * Will only render if the type of the message is in this array
     */
    typeFilter?: (type?: string) => boolean;
}

export class ReposMessages extends VssComponent<IReposMessagesProps> {
    public render() {
        const { typeFilter } = this.props;
        const messagesService = this.context.pageContext.getService<IReposMessagesService>("IReposMessagesService");
        const useSuggestions = this.props.showPullRequestSuggestions !== false;
        return (
            <Observer message={messagesService.getMessage(useSuggestions)}>
                {(props: { message?: IRepositoryMessage }) => {
                    return props.message &&
                        (typeFilter ? typeFilter(props.message.type) : true) &&
                        (useSuggestions || props.message.type !== PullRequestSuggestionMessageType) ? (
                        <MessageCard
                            className={this.props.className}
                            severity={props.message.severity || MessageCardSeverity.Info}
                            onDismiss={() => messagesService.dismissMessage()}
                            buttonProps={props.message.buttons}
                        >
                            {props.message.renderMessage()}
                        </MessageCard>
                    ) : null;
                }}
            </Observer>
        );
    }
}
